import styled, { css } from 'styled-components';

import { Facepile } from '@xing-com/facepile';

// *** Base ***
const baseSocialProofFacePile = css`
  * {
    padding: 0;
  }
`;

// *** Components ***
const SocialProofFacepile = styled(Facepile)`
  ${baseSocialProofFacePile}
`;

export const Styled = {
  SocialProofFacepile,
};
